(function (factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else factory().mount(document);
})(function () {
  'use strict';

  function mount(document) {
    const window = document.defaultView;
    if (!window) return;

    document.querySelectorAll('[data-guide-lab]').forEach((root) => {
      if (root.dataset.labReady === 'true') return;
      const find = (selector) => root.querySelector(selector);
      const all = (selector) => [...root.querySelectorAll(selector)];
      const status = (message) => { find('[data-lab-status]').textContent = message; };
      let config;
      try { config = JSON.parse(find('[data-lab-config]').textContent); }
      catch (_) { return; }
      let exportText;
      let copyMessage;
      // The worksheet's file name and message come from its config, so a
      // checklist for another subject reuses this code (defaults: the email sheet).
      let downloadName = 'email-review-notes.txt';
      let downloadMessage = 'Download started. The notes include any boxes you left unchecked.';
      const downloads = new Map();

      function refreshExport() {
        if (!find('[data-lab-export-box]').hidden) find('[data-lab-export]').value = exportText();
      }
      function showText(message) {
        const output = find('[data-lab-export]');
        output.value = exportText();
        find('[data-lab-export-box]').hidden = false;
        output.focus({ preventScroll: true });
        output.select();
        status(message);
      }
      async function copy() {
        const value = exportText();
        try {
          if (!window.navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await window.navigator.clipboard.writeText(value);
          status(copyMessage);
        } catch (_) {
          showText('Copy is not available here. Select this text and copy it.');
        }
      }
      function revokeDownload(url) {
        window.clearTimeout(downloads.get(url));
        window.URL.revokeObjectURL(url);
        downloads.delete(url);
      }
      function download() {
        if (!window.URL?.createObjectURL) {
          showText('Download is not available here. Copy these notes into a text file.');
          return;
        }
        const url = window.URL.createObjectURL(new window.Blob([exportText()], { type: 'text/plain;charset=utf-8' }));
        const link = document.createElement('a');
        link.href = url;
        link.download = downloadName;
        link.hidden = true;
        root.append(link);
        link.click();
        link.remove();
        downloads.set(url, window.setTimeout(() => revokeDownload(url), 1000));
        status(downloadMessage);
      }

      if (root.dataset.guideLab === 'inbox') {
        if (!Array.isArray(config.examples) || !config.examples.length) return;
        const example = find('[data-inbox-example]');
        const subject = find('[data-inbox-subject]');
        const preview = find('[data-inbox-preview]');
        let guideExample;
        exportText = () => `Subject: ${subject.value}\nPreview text: ${preview.value}`;
        copyMessage = 'Copied both lines.';
        function update() {
          const subjectView = find('[data-inbox-subject-view]');
          const previewView = find('[data-inbox-preview-view]');
          subjectView.textContent = subject.value || 'Your subject will show here';
          previewView.textContent = preview.value || 'Your preview text will show here';
          subjectView.dataset.empty = String(!subject.value);
          previewView.dataset.empty = String(!preview.value);
          refreshExport();
        }
        function reset() {
          const chosen = example.value === 'guide-example' ? guideExample : config.examples.find((item) => item.id === example.value);
          if (!chosen) return;
          subject.value = chosen.subject;
          preview.value = chosen.preview;
          find('[data-inbox-original-subject]').textContent = chosen.subject;
          find('[data-inbox-original-preview]').textContent = chosen.preview;
          update();
          status(`${chosen.label} example loaded.`);
        }
        subject.addEventListener('input', update);
        preview.addEventListener('input', update);
        example.addEventListener('change', reset);
        find('[data-inbox-reset]').addEventListener('click', reset);
        document.querySelectorAll('[data-inbox-try]').forEach((button) => {
          button.disabled = false;
          button.addEventListener('click', () => {
            guideExample = { label: 'Guide', subject: button.dataset.subject || '', preview: button.dataset.preview || '' };
            if (!example.querySelector('option[value="guide-example"]')) {
              const option = document.createElement('option');
              option.value = 'guide-example';
              option.textContent = 'Example from this guide';
              option.disabled = true;
              example.append(option);
            }
            example.value = 'guide-example';
            reset();
            subject.focus({ preventScroll: true });
            const reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : true;
            if (root.scrollIntoView) root.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          });
        });
        all('[data-inbox-size]').forEach((button) => button.addEventListener('click', () => {
          find('[data-inbox-window]').dataset.inboxWindow = button.dataset.inboxSize;
          all('[data-inbox-size]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        }));
        update();
      } else if (root.dataset.guideLab === 'cta') {
        if (!Array.isArray(config.goals) || !config.goals.length) return;
        const buttonText = find('[data-cta-button]');
        const link = find('[data-cta-link]');
        const previewButton = find('[data-cta-open]');
        const destination = find('[data-cta-destination]');
        let goal = config.goals.find((item) => item.id === find('[data-cta-goal]:checked').value);
        if (!goal) return;
        exportText = () => `Button and link plan\n\nReader's next step: ${goal.label}\nButton text: ${buttonText.value || '[Add button text]'}\nLink opens: ${goal.target}\nYour link: ${link.value || '[Add your link]'}\n\nCheck: ${goal.hint}`;
        copyMessage = 'Copied your button and link plan.';
        function update() {
          const view = find('[data-cta-button-view]');
          view.textContent = buttonText.value || 'Your button text';
          view.dataset.empty = String(!buttonText.value);
          refreshExport();
        }
        all('[data-cta-goal]').forEach((radio) => radio.addEventListener('change', () => {
          if (!radio.checked) return;
          const next = config.goals.find((item) => item.id === radio.value);
          if (!next) return;
          goal = next;
          destination.hidden = true;
          previewButton.setAttribute('aria-expanded', 'false');
          buttonText.value = goal.button;
          link.value = '';
          find('[data-cta-target]').textContent = goal.target;
          find('[data-cta-hint]').textContent = goal.hint;
          find('[data-cta-heading]').textContent = goal.heading;
          find('[data-cta-body]').textContent = goal.body;
          update();
          status(`${goal.label} chosen. The button and suggested link now match. Add your link if you have it.`);
        }));
        buttonText.addEventListener('input', update);
        link.addEventListener('input', refreshExport);
        previewButton.disabled = false;
        previewButton.addEventListener('click', () => {
          find('[data-cta-destination-path]').textContent = goal.destination.path;
          find('[data-cta-destination-title]').textContent = goal.destination.title;
          find('[data-cta-destination-detail]').textContent = goal.destination.detail;
          destination.hidden = false;
          previewButton.setAttribute('aria-expanded', 'true');
          destination.focus({ preventScroll: true });
          const reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : true;
          destination.scrollIntoView?.({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
        });
        update();
      } else if (root.dataset.guideLab === 'worksheet') {
        if (!Array.isArray(config.groups) || !config.groups.length) return;
        const checks = all('[data-review-check]');
        const name = find('[data-review-name]');
        const notes = find('[data-review-notes]');
        const text = Object.assign({
          exportTitle: 'Email review notes',
          exportName: 'Email',
          countLabel: 'marked as reviewed',
          notesLabel: 'Fixes and notes',
          exportClosing: 'These are my review notes. They are not the result of an email test. Other checks may still be needed.',
          filename: 'email-review-notes.txt',
          copied: 'Copied your notes, including any unchecked boxes.',
          downloaded: 'Download started. The notes include any boxes you left unchecked.'
        }, config.text || {});
        downloadName = text.filename;
        downloadMessage = text.downloaded;
        exportText = () => {
          const reviewed = new Set(checks.filter((check) => check.checked).map((check) => check.dataset.reviewCheck));
          return [
            text.exportTitle,
            `${text.exportName}: ${name.value || '[No name added]'}`,
            `${reviewed.size} of ${checks.length} ${text.countLabel}; ${checks.length - reviewed.size} unchecked.`,
            '',
            ...config.groups.flatMap((group) => [group.title, ...group.checks.map(([id, label]) => `${reviewed.has(id) ? '[x]' : '[ ]'} ${label}`), '']),
            text.notesLabel, notes.value || '[No notes added]', '',
            text.exportClosing
          ].join('\n');
        };
        copyMessage = text.copied;
        function update() {
          const count = checks.filter((check) => check.checked).length;
          find('[data-review-count]').textContent = `${count} of ${checks.length} ${text.countLabel}`;
          find('[data-review-progress]').value = count;
          refreshExport();
        }
        checks.forEach((check) => check.addEventListener('change', update));
        name.addEventListener('input', refreshExport);
        notes.addEventListener('input', refreshExport);
        find('[data-review-download]').addEventListener('click', download);
        update();
      } else return;

      root.dataset.labReady = 'true';
      all('[data-lab-controls]').forEach((fieldset) => { fieldset.disabled = false; });
      find('[data-lab-copy]').addEventListener('click', copy);
      window.addEventListener('pagehide', () => [...downloads.keys()].forEach(revokeDownload));
    });
  }

  return { mount };
});
